import * as React from 'react';

import { InjectedRouter } from 'react-router';

// @ts-ignore
import PromptActions from 'actions/PromptActions';
import ToastActions from 'actions/ToastActions';
import { withRouter } from 'app/context/Router';
import CurrentUser from 'auth/CurrentUser';
import BoxBody from 'components/BoxBody';
import Button from 'components/ButtonDeprecated';
import DialogContent from 'components/DialogContent';
import FormDeprecated from 'components/FormDeprecated';
// @ts-ignore
import FormInput from 'components/FormInput';
// @ts-ignore
import FormSelect from 'components/FormSelect';
// @ts-ignore
import { PromptNames } from 'constants/PromptConstants';
// @ts-ignore
import Prefixes from 'lib/Prefixes';
// @ts-ignore
import PromptStore from 'stores/PromptStore';
// @ts-ignore
import UserActions from 'user/UserActions';

import './styles/SetupSignature.scss';

type Props = {
  router: InjectedRouter;
  location: any;
};

type State = {
  enabled: boolean;
  prefix: string;
};

class SetupSignature extends React.Component<Props, State> {
  state = {
    enabled: false,
    prefix: CurrentUser.getUser().getPrefix() || '',
  };

  componentDidMount() {
    if (!PromptStore.hasDismissed(PromptNames.NUX_SETUP_SIGNATURE)) {
      PromptActions.recordDismissal(PromptNames.NUX_SETUP_SIGNATURE);
    }
  }

  updatePrefix = (prefix: string) => {
    this.setState({ prefix });
  };

  submit = (attrs: { prefix: string; signature: string }) => {
    const onSuccess = () => {
      ToastActions.showSuccessToast('Saved!');
      this.props.router.push(this.props.location?.state?.location ?? '/');
    };

    const onFailure = (error: any) => ToastActions.showAPIError(error);

    if (attrs.prefix) {
      attrs.signature = attrs.prefix + ' ' + attrs.signature;
    }

    UserActions.update(attrs).then(onSuccess, onFailure);
  };

  render() {
    // if there's a prefix we concat the signature and the prefix
    // so the max length of the signature is not 18 but (18 - 'Mr. '.length)
    const maxLength =
      this.state.prefix.length > 0 ? 18 - (this.state.prefix.length + 1) /* space */ : 18;

    return (
      <DialogContent
        size="small"
        className="SetupSignature"
        title="What do students and parents call you?">
        <BoxBody divided>
          <div className="SetupSignature">
            <FormDeprecated
              onValidSubmit={this.submit}
              onValid={() => this.setState({ enabled: true })}
              onInvalid={() => this.setState({ enabled: false })}>
              <div className="SetupSignature-Title">
                <FormSelect
                  label="Title"
                  name="prefix"
                  value={this.state.prefix}
                  onChange={this.updatePrefix}
                  options={Prefixes}
                  placeholder="[No title]"
                  searchable={false}
                />
              </div>
              <div className="SetupSignature-Name">
                <FormInput
                  label="Name"
                  required
                  name="signature"
                  showErrorOnPristine
                  value={CurrentUser.getUser().getSignature()}
                  validations={{ maxLength }}
                  validationErrors={{
                    maxLength: `Signature should be shorter than ${maxLength + 1} characters.`,
                  }}
                />
              </div>
              <Button
                disabled={!this.state.enabled}
                className="SetupSignature-Submit"
                type="submit"
                eventElementName="SetupSignature-Submit">
                Next
              </Button>
            </FormDeprecated>
          </div>
        </BoxBody>
      </DialogContent>
    );
  }
}

export { SetupSignature };
export default withRouter(SetupSignature);
